<template>
  <v-hover open-delay="500">
    <template v-slot="{ hover }">
      <v-navigation-drawer
        id="appDrawer"
        :clipped="true"
        :mini-variant="isMini && !hover"
        fixed
        :width="285"
        app
      >
        <!-- small & medium screen sidebar -->
        <v-list dense expand>
          <template v-for="(item, i) in routes">
            <!--List headers-->
            <v-subheader v-if="item.header" :key="i">
              {{ item.header }}
            </v-subheader>
            <!--List divider-->
            <v-divider v-else-if="item.divider" :key="i"></v-divider>
            <!--top-level link-->
            <v-list-item
              v-else
              active-class="activeRoute"
              class="px-0"
              :to="{ name: item.name }"
              @click="makeLoading(item.path)"
              ripple="ripple"
              :key="i"
            >
              <v-list-item-action>
                <v-progress-circular
                  indeterminate
                  size="24"
                  v-if="item.path === isLoading"
                ></v-progress-circular>
                <v-icon color="primary" v-else>{{ item.meta.icon }}</v-icon>
              </v-list-item-action>
              <span class="routeItem">
                {{ generateRouteTitle(item.meta.title) }}
              </span>
            </v-list-item>
          </template>
        </v-list>
      </v-navigation-drawer>
    </template>
  </v-hover>
</template>

<script>
import { mapGetters } from 'vuex';
import { generateRouteTitle } from '@/utils/i18n';
import { AUTHORIZATION_MODULE_PATH } from '@/store/modules/authorization';

export default {
  name: 'c-navigation-drawer',
  computed: {
    routes() {
      const routes = this.$router.options.routes.find(
        (element) => element.name === 'Root'
      );
      return routes.children.filter(
        (element) =>
          !element.meta.isHidden && this.hasAccess(element.meta.authorizations)
      );
    },
    ...mapGetters({
      sidebar: 'boilerplate/sidebar',
      isLoading: 'boilerplate/isLoading',
      delayedModules: 'boilerplate/delayedModules',
      hasAccess: `${AUTHORIZATION_MODULE_PATH}/hasAccess`,
    }),
    isMini: {
      get() {
        return !this.sidebar.opened;
      },
      set(val) {
        this.$store.dispatch('boilerplate/setSideBarOpened', val);
      },
    },
  },
  methods: {
    genChildTarget(item, subItem) {
      if (subItem.component) {
        return { name: subItem.component };
      }
      return `${item.group}/${subItem.name}`;
    },
    generateRouteTitle,
    makeLoading(path) {
      if (this.delayedModules.includes(path)) {
        this.$store.dispatch('boilerplate/setLoading', path);
      }
    },
  },
};
</script>

<style lang="stylus">
#appDrawer {
  overflow: hidden;

  .drawer-menu--scroll {
    height: calc(100vh - 48px);
    overflow: auto;
  }
  .v-list-item--active{
    color: #009de9
  }
}
</style>
<style scoped>
.activeRoute {
  border-left: 4px solid #009de9;
  font-weight: bold !important;
}
.routeItem {
  line-height: 1rem;
  font-size: 0.8125rem;
}
</style>
